import { Link } from 'react-router-dom';
import { useTranslation } from '@sib/i18n';
import { Button } from '@sib/ui';
import { InformationWrapper } from '@sib/ui';
import { PageNotFound as PageNotFoundIcon } from '@sib/ui/icons';
import { paths } from '@spendbrain/config/paths';

export const PageNotFound = () => {
  const { t } = useTranslation();

  return (
    <InformationWrapper
      icon={<PageNotFoundIcon className="size-15" />}
      title={t('errors.pageNotFound.title')}
      description={t('errors.pageNotFound.description')}
      customIconClassName="p-6"
      footer={
        <Button asChild className="h-10">
          <Link to={paths.dashboard}>
            {t('errors.redirect', { module: t('errors.modules.dashboard') })}
          </Link>
        </Button>
      }
    />
  );
};
